export default __webpack_public_path__ + "static/media/pv2.9d94b751.png";